'use strict';

/** @type {import('./syntax')} */
module.exports = SyntaxError;



//////////////////
// WEBPACK FOOTER
// ./~/es-errors/syntax.js
// module id = XHij
// module chunks = 78